/**
 * Application metadata
 */
export const APP_NAME = 'Unreserved Real Estate';
export const APP_VERSION = '1.0.0';
export const APP_DESCRIPTION = 'Your trusted real estate platform';

/**
 * Local storage keys
 */
export const LOCAL_STORAGE_KEYS = {
  USER: 'user',
  THEME: 'theme',
  LANGUAGE: 'language',
  KYC_VERIFICATION_ID: 'kyc_verification_id',
} as const;

/**
 * Session storage keys
 */
export const SESSION_STORAGE_KEYS = {
  REDIRECT_URL: 'redirect_url',
  FORM_DATA: 'form_data',
} as const;

/**
 * Cookie names
 */
export const COOKIE_NAMES = {
  AUTH_TOKEN: 'x-access-token',
  REFRESH_TOKEN: 'x-refresh-token',
  CONSENT: 'cookie_consent',
} as const;

/**
 * Breakpoints (in pixels)
 */
export const BREAKPOINTS = {
  MOBILE: 640,
  TABLET: 768,
  DESKTOP: 1024,
  WIDE: 1280,
  ULTRA_WIDE: 1536,
} as const;

/**
 * Timeouts (in milliseconds)
 */
export const TIMEOUTS = {
  API_REQUEST: 30000,
  DEBOUNCE: 300,
  TOAST: 2000,
  TOOLTIP: 200,
} as const;

/**
 * Pagination defaults
 */
export const PAGINATION = {
  DEFAULT_PAGE: 1,
  DEFAULT_LIMIT: 10,
  MAX_LIMIT: 100,
} as const;

/**
 * Default country code for phone inputs
 */
export const DEFAULT_COUNTRY_CODE = '+61';

/**
 * test file URLs for development, guys don't override this until we have actual api integration.
 */
export const TEST_FILE_URLS = {
  VIDEO:
    'https://commondatastorage.googleapis.com/gtv-videos-bucket/sample/BigBuckBunny.mp4',
  YOUTUBE_VIDEO: 'https://youtu.be/wDchsz8nmbo?si=F6u8ojst231RN3D5',
  POSTER:
    'https://media.gettyimages.com/id/1307786410/video/play-button-live-streaming-template-red-sign-of-streaming-broadcasting-online-video-4k-video.jpg?s=640x640&k=20&c=SPGisAIfqqJcWXkYFNAaiDi37VHZgU_1-6WOormW2L8=',
} as const;

/**
 * dummy text for development, guys don't override this until w.
 */
export const DUMMY_TEXTS = {
  PROPERTY_DETAILS_FOOTER_SECTIONS: [
    'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.',
    'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt.',
    'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.',
  ] as const,
} as const;

/**
 * regex
 */
export const YOUTUBE_REGEX =
  /^(?:https?:\/\/)?(?:www\.)?(?:m\.)?(?:youtu\.be\/|youtube\.com\/(?:embed\/|v\/|watch\?(?:.*&)?v=|shorts\/|live\/))([^"&?\/\s]{11})/;
export const VIMEO_REGEX =
  /^(?:https?:\/\/)?(?:www\.)?(?:player\.)?vimeo\.com\/(?:video\/)?(\d+)/;

/**
 * static features for the get estimates page footer
 */

export const FEATURES = [
  { id: 1, label: 'Instant AVM price' },
  { id: 2, label: 'Refine with improvements' },
  { id: 3, label: 'Save & email report' },
];

/**
 * file type presets
 */
export const FILE_TYPE_PRESETS = {
  images: {
    extensions: ['.jpg', '.jpeg', '.png', '.webp'],
    mimeTypes: ['image/jpeg', 'image/png', 'image/webp'],
    label: 'JPG, JPEG, PNG, WebP',
  },
  documents: {
    extensions: ['.pdf', '.doc', '.docx'],
    mimeTypes: [
      'application/pdf',
      'application/msword',
      'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
    ],
    label: 'PDF, Word document (.doc, .docx)',
  },
  pdfs: {
    extensions: ['.pdf'],
    mimeTypes: ['application/pdf'],
    label: 'PDF',
  },
  videos: {
    extensions: ['.mp4', '.webm', '.ogg', '.mov', '.avi', '.mkv', '.m4v'],
    mimeTypes: [
      'video/mp4',
      'video/webm',
      'video/ogg',
      'video/mov',
      'video/avi',
      'video/mkv',
      'video/m4v',
    ],
    label: 'MP4, WEBM, OGG, MOV, AVI, MKV, M4V',
  },
  'images-documents': {
    extensions: ['.pdf', '.doc', '.docx', '.jpg', '.jpeg', '.png', '.webp'],
    mimeTypes: [
      'application/pdf',
      'application/msword',
      'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
      'image/jpeg',
      'image/png',
      'image/webp',
    ],
    label: 'PDF, Word document (.doc, .docx), JPG, JPEG, PNG, WebP',
  },
} as const;
